import classNames from "components/ui/classNames";
import { palette } from "lib/miolo";
import type { ReactNode } from "react";

interface IStaticContentSectionProps {
  primaryColor?: string;
  children: ReactNode;
  className?: string;
}

export default function StaticContentSection({
  primaryColor = palette.mariner,
  children,
  className,
  ...props
}: IStaticContentSectionProps) {
  return (
    <div
      className={classNames(
        "relative grid grid-cols-12 rounded-xl border border-slate-200 bg-white p-6 shadow-sm",
        className,
      )}
      {...props}
    >
      {primaryColor && (
        <div
          aria-hidden={true}
          className="absolute -left-0.5 top-4 w-1 rounded"
          style={{
            height: "calc(100% - 32px)",
            backgroundColor: primaryColor,
          }}
        />
      )}
      {children}
    </div>
  );
}
